define("tmds/renderers/SimpleRenderer", [
    "jquery",
    "./Renderer",
    "tmds/utils/symbolUtils",
    '../validator'
], function($, Renderer, symUtils, validator) {
	"use strict";
	
	/**
	 * construct a new SimpleRenderer
	 * @param options {Object} input JSON object with below structure
	 * 		{
	 * 			symbol: {
	 * 				type: "SimplePointSymbol",
	 * 				style: 'square',
	 * 				color: [255,0,0,0.5],
	 * 				size: 12
	 * 			}
	 * 		}
	 * @note options with symbol property is required.
	 */
	var SimpleRenderer = function(options) {
		
		if (validator.isDataObject(options) && validator.isDataObject(options.symbol)) {
			
			this.symbol = symUtils.fromJson(options.symbol);
		}
		else {
			throw new Error(this.declaredClass + ": symbol property is missing in the constructor parameter.");
		}
	};
	
	/**
	 * convert SimpleRenderer object to JSON representation
	 */
	function toJson() {
		return {
			type: this.type,
			symbol: this.symbol.toJson()
		};
	}
	
	SimpleRenderer.prototype = $.extend(Object.create(Renderer.prototype), {
		declaredClass: "tmds.renderers.SimpleRenderer",
		type: "SimpleRenderer",
		'toJson' : toJson
	});
	
	return SimpleRenderer;
});
